import { DigestType, DigestType as DigestTypeApi, isValidDigest } from './Digest';
const digestTypeApiToDigestTypeMap = {
  [DigestTypeApi.UNKNOWN_DIGEST_TYPE]: DigestType.UNKNOWN_DIGEST_TYPE,
  [DigestTypeApi.TASK]: DigestType.TASK,
  [DigestTypeApi.ROUTINE]: DigestType.ROUTINE,
  [DigestTypeApi.CATEGORY]: DigestType.CATEGORY
};
const digestTypeApiToDigestType = type => {
  if (!type) {
    throw new Error('Digest type is required');
  }
  const digestType = digestTypeApiToDigestTypeMap[type];
  if (!digestType) {
    throw new Error('Invalid digest type', {
      cause: type
    });
  }
  return digestType;
};
export function digestApiToDigestEntity(digestApi) {
  if (!digestApi) {
    throw new Error('digestApi is required');
  }
  const maybeDigest = {
    id: digestApi.id,
    revision: digestApi.revision,
    type: digestTypeApiToDigestType(digestApi.type),
    entityId: digestApi.entityId,
    data: digestApi.data
  };
  if (!isValidDigest(maybeDigest)) {
    throw new Error('Invalid digest API', {
      cause: maybeDigest
    });
  }
  return maybeDigest;
}
//# sourceMappingURL=converters.js.map